import React, { Fragment, useState, useEffect } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import CardHeader from '@material-ui/core/CardHeader';
import { makeStyles } from '@material-ui/core/styles';
import Checkbox from '@material-ui/core/Checkbox';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import { Field } from 'redux-form';
import StudentCard from '../../../shared/components/StudentCard';
import Modal from '../../../shared/components/Modal';
import renderField from '../../../shared/components/form/RenderField';

const MenuStudentRelationMaintenance = (props) => {
  const {
    t,
    leftTitle,
    rightTitle,
    updateRelatedStudents,
    selectedStudents,
    setSelectStudent,
    studentsToSelect,
    setUnSelectStudent,
  } = props;
  const [checked, setChecked] = useState([]);
  const [studentTransferenceArea, setStudentTransferenceArea] = useState([]);
  const [confirmTransference, setConfirmTransference] = useState(false);

  const useStyles = makeStyles((theme) => ({
    cardHeader: {
      padding: theme.spacing(1, 2),
      border: '1px solid #f2f4f7',
    },
    list: {
      height: 400,
      backgroundColor: theme.palette.background.paper,
      overflow: 'auto',
      border: '1px solid #f2f4f7',
    },
    button: {
      margin: theme.spacing(0.5, 0),
    },
  }));

  function not(a, b) {
    return a.filter((value) => b.indexOf(value) === -1);
  }

  function intersection(a, b) {
    return a.filter((value) => b.indexOf(value) !== -1);
  }

  function union(a, b) {
    return [...a, ...not(b, a)];
  }

  const leftChecked = intersection(checked, studentsToSelect);
  const rightChecked = intersection(checked, selectedStudents);
  const classes = useStyles();

  const handleToggle = (value) => () => {
    const currentIndex = checked.indexOf(value);
    const newChecked = [...checked];

    if (currentIndex === -1) {
      newChecked.push(value);
    } else {
      newChecked.splice(currentIndex, 1);
    }
    setChecked(newChecked);
  };

  const numberOfChecked = (items) => intersection(checked, items).length;

  const handleToggleAll = (items) => () => {
    if (numberOfChecked(items) === items.length) {
      setChecked(not(checked, items));
    } else {
      setChecked(union(checked, items));
    }
  };

  const toggleStudentTransferenceModal = () => {
    setConfirmTransference(!confirmTransference);
  };

  const handleCheckedRight = () => {
    const updatedSelectedList = selectedStudents.concat(leftChecked);
    const relatedStudents = leftChecked.filter((item) => item.menuId);
    if (!relatedStudents.length) {
      setSelectStudent(updatedSelectedList);
      setUnSelectStudent(not(studentsToSelect, leftChecked));
      setChecked(not(checked, leftChecked));
      updateRelatedStudents(updatedSelectedList);
    } else {
      setStudentTransferenceArea(updatedSelectedList);
      toggleStudentTransferenceModal();
    }
  };

  const handleCheckedLeft = () => {
    const updatedSelectedList = not(selectedStudents, rightChecked);
    setUnSelectStudent(studentsToSelect.concat(rightChecked));
    setSelectStudent(updatedSelectedList);
    setChecked(not(checked, rightChecked));
    updateRelatedStudents(updatedSelectedList);
  };

  const confirmStudentTransferenceHandler = () => {
    setSelectStudent(studentTransferenceArea);
    setUnSelectStudent(not(studentsToSelect, leftChecked));
    setChecked(not(checked, leftChecked));
    updateRelatedStudents(studentTransferenceArea);
    toggleStudentTransferenceModal();
  };

  const [inicialState, setInicialState] = useState([]);
  const [unselectedStudents, setUnselectedStudents] = useState([]);
  const [selectedStudentsMenu, setSelectedStudentsMenu] = useState([]);

  useEffect(() => {
    setInicialState(studentsToSelect);
    setUnselectedStudents(studentsToSelect);
    setSelectedStudentsMenu(selectedStudents);
  }, [studentsToSelect, selectedStudents]);

  const handleChange = ({ target }) => {
    if (target.name === 'listaStudents') {
      if (!target.value) {
        setUnselectedStudents(inicialState);
        return;
      }

      const filterStudent = unselectedStudents.filter((repo) =>
        repo.studentName.toLowerCase().includes(target.value.toLowerCase())
      );

      setUnselectedStudents(filterStudent);
    } else {
      if (!target.value) {
        setSelectedStudentsMenu(selectedStudents);
        return;
      }

      const filterAluno2 = selectedStudentsMenu.filter((repo) =>
        repo.studentName.toLowerCase().includes(target.value.toLowerCase())
      );

      setSelectedStudentsMenu(filterAluno2);
    }
  };

  const customList = (title, items) => (
    <Fragment>
      <Field
        name="listaStudents"
        type="text"
        component={renderField}
        value={inicialState}
        onChange={handleChange}
      />
      <CardHeader
        className={classes.cardHeader}
        avatar={
          <Checkbox
            onClick={handleToggleAll(items)}
            checked={
              numberOfChecked(items) === items.length && items.length !== 0
            }
            indeterminate={
              numberOfChecked(items) !== items.length &&
              numberOfChecked(items) !== 0
            }
            disabled={items.length === 0}
            inputProps={{ 'aria-label': 'all items selected' }}
            className={classes.checkbox}
          />
        }
        title={title}
        subheader={`${numberOfChecked(items)}/${items.length} ${t(
          'general.selected'
        )}`}
      />
      <List className={classes.list} dense component="div" role="list">
        {items.map((value) => {
          const labelId = `transfer-list-all-item-${value.studentId}-label`;
          return (
            <ListItem
              key={`${value.studentId}-${value.id}`}
              role="listitem"
              button
              onClick={handleToggle(value)}
            >
              <ListItemIcon>
                <Checkbox
                  checked={checked.indexOf(value) !== -1}
                  tabIndex={-1}
                  disableRipple
                  inputProps={{ 'aria-label': labelId }}
                />
              </ListItemIcon>
              <StudentCard id={value.studentId} student={value} />
            </ListItem>
          );
        })}
        <ListItem />
      </List>
    </Fragment>
  );

  const customList2 = (title, items) => (
    <Fragment>
      <Field
        name="menuStudents"
        type="text"
        component={renderField}
        value={inicialState}
        onChange={handleChange}
      />
      <CardHeader
        className={classes.cardHeader}
        avatar={
          <Checkbox
            onClick={handleToggleAll(items)}
            checked={
              numberOfChecked(items) === items.length && items.length !== 0
            }
            indeterminate={
              numberOfChecked(items) !== items.length &&
              numberOfChecked(items) !== 0
            }
            disabled={items.length === 0}
            inputProps={{ 'aria-label': 'all items selected' }}
            className={classes.checkbox}
          />
        }
        title={title}
        subheader={`${numberOfChecked(items)}/${items.length} ${t(
          'general.selected'
        )}`}
      />
      <List className={classes.list} dense component="div" role="list">
        {items.map((value) => {
          const labelId = `transfer-list-all-item-${value.studentId}-label`;
          return (
            <ListItem
              key={`${value.studentId}-${value.id}`}
              role="listitem"
              button
              onClick={handleToggle(value)}
            >
              <ListItemIcon>
                <Checkbox
                  checked={checked.indexOf(value) !== -1}
                  tabIndex={-1}
                  disableRipple
                  inputProps={{ 'aria-label': labelId }}
                />
              </ListItemIcon>
              <StudentCard id={value.studentId} student={value} />
            </ListItem>
          );
        })}
        <ListItem />
      </List>
    </Fragment>
  );

  return (
    <Fragment>
      <Grid container xl justify="center" alignItems="center">
        <Grid item xl xs>
          {customList(leftTitle, unselectedStudents)}
        </Grid>
        <Grid item xl={1}>
          <Grid container direction="column" alignItems="center">
            <Button
              variant="outlined"
              size="small"
              className={classes.button}
              onClick={handleCheckedRight}
              disabled={leftChecked.length === 0}
              aria-label="move selected right"
            >
              &gt;
            </Button>
            <Button
              variant="outlined"
              size="small"
              className={classes.button}
              onClick={handleCheckedLeft}
              disabled={rightChecked.length === 0}
              aria-label="move selected left"
            >
              &lt;
            </Button>
          </Grid>
        </Grid>
        <Grid item xl xs>
          {customList2(rightTitle, selectedStudentsMenu)}
        </Grid>
      </Grid>
      <Modal
        color="warning"
        title={t('notifications.attention')}
        btn="Warning"
        message={t('menus-student-relation.transference-confirmation')}
        toggle={toggleStudentTransferenceModal}
        modal={confirmTransference}
        onConfirm={confirmStudentTransferenceHandler}
      />
    </Fragment>
  );
};

MenuStudentRelationMaintenance.propTypes = {
  t: PropTypes.func.isRequired,
  leftTitle: PropTypes.string.isRequired,
  rightTitle: PropTypes.string.isRequired,
  setSelectStudent: PropTypes.func.isRequired,
  updateRelatedStudents: PropTypes.func.isRequired,
  setUnSelectStudent: PropTypes.func.isRequired,
  selectedStudents: PropTypes.arrayOf(PropTypes.shape(PropTypes.shape))
    .isRequired,
  studentsToSelect: PropTypes.arrayOf(PropTypes.shape(PropTypes.shape))
    .isRequired,
};

export default withTranslation('common')(
  connect((state) => ({
    loading: state.loading,
  }))(MenuStudentRelationMaintenance)
);
